import {betMoney} from 'app/utils';
import {isPlayMoney} from 'app/lines/isPlayMoney';

export const amountCurrency = (amount: string, type: string): string => {
    const amountF = betMoney({amount: amount.replace(/,/u, '')}, null, false, true);
    return isPlayMoney(type) ? `PM ${amountF}` : `$${amountF}`;
};
